<div class="col-sm-12" id="ficheCltFiche" style="padding: 0;" (click)="common.outSide($event)"
  [ngStyle]="{'height': isDepuisMenuEnHaut ? 'calc(100% - 10px)' : '100%', 'padding-top': isDepuisMenuEnHaut ? '0px' : '0px' }">

  <!--div class="col-sm-12" style="padding: 0; padding-top: 5px;" [ngStyle]="{'height': isDepuisMenuEnHaut ? 'calc(100% - 10px)' : '100%'}"-->

  <div class="pull-{{position ? 'right' : 'left'}}" [ngClass]="{'col-sm-6': showcht, 'col-sm-12': !showcht}"
    [ngStyle]="{'width': isDepuisMenuEnHaut ? '' : '500px'}" style="padding: 0; height: 100%;"
    *ngIf="!isEmpty && !showcht  && !showFactAuto">
    <!--
<div class="pull-{{position ? 'right' : 'left'}}" [ngClass]="{'col-sm-6': showcht, 'col-sm-12': !showcht}"
    style="width: 500px; padding: 0; height: 100%;" *ngIf="!isEmpty && !showcht  && !showFactAuto">
-->
    <div class="fiche panelHautFicheClient">
      <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
        <div class="col-sm-6 fiche-client">
          <div class="detailclt clientBloquer" *ngIf="!add"> {{ detail.codeClient }} / {{ detail.nomClient }} </div>
          <span class="col-sm-12 ville clientBloquer" *ngIf="!add"> {{ detail.ville }} <span class="clientBloquer"
              style="padding: 4px; ">{{common.getCodeBlocage(detail.codeBlocage) !== '' ? ('(' +
              common.getCodeBlocage(detail.codeBlocage) + ')') : ''}}</span> </span>
          <div class="detailclt" *ngIf="add"> Création client</div>
        </div>
        <button class="uppercase" id="saveclt" *ngIf="edit && !add  && common.isModifClient" (click)="updateClient()"
          [ngStyle]="{'display': isDepuisMenuEnHaut ? 'none' : 'inline-block'}">
          Enregistrer
        </button>
        <button class="uppercase" *ngIf="add && activeBtnValiderAdd" id="addclt" (click)="addClient()"
          [ngStyle]="{'display': isDepuisMenuEnHaut ? 'none' : 'inline-block'}"> Valider
        </button>
        <button class="uppercase" *ngIf="!add && !edit && common.isModifClient && !detail.prospectHolding" id="editclt"
          (click)="editClient()" [ngStyle]="{'display': isDepuisMenuEnHaut ? 'none' : 'inline-block'}">Modifier
        </button>
        <button class="uppercase btn-close" id="closeclt" (click)="showFiche()"
          [ngStyle]="{'display': isDepuisMenuEnHaut ? 'none' : 'inline-block'}"> Fermer
        </button>

        <!--
        <button class="uppercase" id="saveclt" *ngIf="edit && !add" (click)="updateClient()"> Enregistrer
        </button>
        <button class="uppercase" *ngIf="add" id="addclt" (click)="addClient()"> Valider </button>
        <button class="uppercase" *ngIf="!edit" id="editclt" (click)="editClient()">Modifier </button>
        <button class="uppercase btn-close" id="closeclt" (click)="showFiche()"> Fermer </button>
        -->
      </div>

      <div class="col-sm-12" style="padding-right: 0;" [ngStyle]="{'padding-top': add ? '5px' : '0px'}"
        *ngIf="!isModifAgence && !isCreateAgence">
        <div class="input-group col-sm-12 recherche">
          <input type="text" id="ficheinput" class="form-control" [(ngModel)]="searchCritere"
            placeholder="Rechercher une donnée client" (keyup.enter)="filtreSearch($event)"
            (ngModelChange)="changeRecherche()" />
          <div class="input-group-addon">
            <img src="assets/images/icons/search.svg" class="pull-right" alt="search"
              (click)="changeInput(searchCritere)" style="cursor : pointer" />
          </div>
        </div>
      </div>
    </div>
    <div class="contente" *ngIf="!isEmpty">
      <div class="info-client col-sm-12 pull-right">
        <ngb-tabset [justify]="'fill'" *ngIf="!isRecherche" [activeId]="activeIdString">
          <ngb-tab title="Général" *ngIf="isGeneral">
            <ng-template ngbTabContent>
              <div class="col-sm-12">
                <div style="font-size: 10px;"> (
                  <span style="color:red;">*</span> ) : Champs obligatoires
                </div>
                <app-general [detail]="detail" [edit]="edit" [add]="add" [hidetitle]="true" [position]="position"
                  (showContact)="showListContact()" (createfct)="addChantier()" (editfct)="editChantier($event)"
                  [agence]="agence" [listeagence]="listeagence" (createfctagence)="createAgence()"
                  (editfctagence)="editAgence($event)" (showUserEcoportail)="showUserEcoportail()"
                  (showDocument)="showDocument()" (showEntTravaux)="showEntTravaux()"
                  (showGestionFIPDND)="showGestionFIPDND()" (showGestionFIPDD)="showGestionFIPDD()"
                  [listeSociete]="listeSociete || []"></app-general>
                <app-info-part [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="isInfoPartInGeneral"
                  [detail]="detail" [edit]="edit" [add]="add" [hidetitle]="true" (ibanBic)="showIBANBIC()">
                </app-info-part>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="Fact." *ngIf="isFact">
            <ng-template ngbTabContent>
              <div class="col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }">
                <app-fact [detail]="detail" [edit]="edit" [add]="add" [hidetitle]="true"
                  (libelleNegocier)="showLibelleNego()"></app-fact>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab *ngIf="isCompta">
            <ng-template ngbTabTitle> Compta</ng-template>
            <ng-template ngbTabContent>
              <div class="col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }">
                <app-compta [detail]="detail" [edit]="edit" [add]="add" [hidetitle]="true" (ibanBic)="showIBANBIC()"
                  (tropPercus)="showTropPercus()" (compteCollTVA)="showCompteArticleTVA()"
                  (montantsTeom)="showMontantsTeom()">
                </app-compta>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="Commerce" *ngIf="isComm" id="3">
            <ng-template ngbTabContent>
              <div class="col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }">
                <app-commerce [detail]="detail" [edit]="edit" [add]="add" [hidetitle]="true" (show)="showFact()"
                  (prixNegocier)="showPrixNego()" (nomenclatureNegocier)="showNomenclature()"
                  (libelleNegocier)="showLibelleNego()" (cap)="showCap()" (capDND)="showCapDND()"
                  (capClient)="showCapClient()" (limiterExutoire)="showLimiteExu()"></app-commerce>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="Solde" *ngIf="isSolde">
            <ng-template ngbTabContent>
              <div class="col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }">
                <app-solde [detail]="detail" [edit]="edit" [add]="add" [hidetitle]="true"
                  (prixNegocier)="showPrixNego()"></app-solde>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="Info. Part." *ngIf="isInfoPart">
            <ng-template ngbTabContent>
              <div class="col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }">
                <app-info-part [detail]="detail" [edit]="edit" [add]="add" [hidetitle]="true" (ibanBic)="showIBANBIC()">
                </app-info-part>
              </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
        <div class="col-sm-12" *ngIf="isRecherche"
          style="background-color: #dbe8f8; padding: 5px 20px; letter-spacing: 2px;"> Résultat de la recherche
        </div>
        <div class="col-sm-12 searchblock" *ngIf="searchCritere.length"
          [ngStyle]="{'display': isRecherche ? 'block': 'none'}">
          <div style="font-size: 10px;"> (
            <span style="color:red;">*</span>) : Champs obligatoires
          </div>
          <app-general [detail]="detail" [edit]="edit" [hidetitle]="true" [add]="add" [position]="position"
            *ngIf="isGeneral" [agence]="agence" [listeagence]="listeagence" [listeSociete]="listeSociete || []"
            (createfctagence)="createAgence()" (editfctagence)="editAgence($event)" (showContact)="showListContact()"
            (show)="showcht ? showcht = false : showChantier()" (createfct)="addChantier()"
            (editfct)="editChantier($event)" (showUserEcoportail)="showUserEcoportail()" (showDocument)="showDocument()"
            (showEntTravaux)="showEntTravaux()" (showGestionFIPDND)="showGestionFIPDND()" (showGestionFIPDD)="showGestionFIPDD()"></app-general>
          <app-fact [detail]="detail" [edit]="edit" [add]="add" [hidetitle]="true" (libelleNegocier)="showLibelleNego()"
            *ngIf="isFact"></app-fact>
          <app-compta [ngClass]="{'disabledbutton': detail.prospectHolding }" [detail]="detail" [edit]="edit"
            [add]="add" [hidetitle]="true" (ibanBic)="showIBANBIC()" (tropPercus)="showTropPercus()"
            (compteCollTVA)="showCompteArticleTVA()" (montantsTeom)="showMontantsTeom()" *ngIf="isCompta">
          </app-compta>
          <app-commerce [ngClass]="{'disabledbutton': detail.prospectHolding }" [detail]="detail" [edit]="edit"
            [add]="add" [hidetitle]="true" (show)="showFact()" *ngIf="isComm" (prixNegocier)="showPrixNego()"
            (nomenclatureNegocier)="showNomenclature()" (libelleNegocier)="showLibelleNego()" (cap)="showCap()"
            (capDND)="showCapDND()" (capClient)="showCapClient()" (limiterExutoire)="showLimiteExu()"></app-commerce>
          <app-solde [ngClass]="{'disabledbutton': detail.prospectHolding }" [detail]="detail" [edit]="edit" [add]="add"
            [hidetitle]="true" (prixNegocier)="showPrixNego()" *ngIf="isSolde"></app-solde>
          <app-info-part [ngClass]="{'disabledbutton': detail.prospectHolding }" [detail]="detail" [edit]="edit"
            [add]="add" [hidetitle]="true" (ibanBic)="showIBANBIC()" *ngIf="isInfoPart">
          </app-info-part>
          <app-info-part [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="isInfoPartInGeneral"
            [detail]="detail" [edit]="edit" [add]="add" [hidetitle]="true" (ibanBic)="showIBANBIC()">
          </app-info-part>
        </div>
      </div>
    </div>
  </div>
  <div class="pull-{{isDepuisMenuEnHaut ? 'none' : (position ? 'right' : 'left')}}" *ngIf="isEmpty"
    style="height: 100%; padding: 40px;background-color: #f9f9f9;"
    [ngStyle]="{'width': isDepuisMenuEnHaut ? '' : '550px'}">
    <!--<div class="pull-{{position ? 'right' : 'left'}}" *ngIf="isEmpty"
    style="height: 100%; padding: 40px;background-color: #f9f9f9; width: 550px;">-->
    <div style="border: 5px solid #efefef; padding: 20px 20px 0; margin-bottom: 30px;">
      <div class="empty"></div>
      <div class="empty"></div>
    </div>

    <div style="border: 5px solid #efefef; padding: 20px 20px 20px 25px;">
      <img src="assets/images/emptyfiche.svg" style="width: 100%;" />
    </div>
  </div>
  <div class=" chantier col-sm-6 pull-{{position ? 'right' : 'left'}}" *ngIf="showcht && !showFactAuto"
    [ngStyle]="{'width': isDepuisMenuEnHaut ? '100%' : '553px', 'min-width': isDepuisMenuEnHaut ? '100%' : '553px'}">
    <div class="col-sm-12" *ngIf="isEdit" style="padding: 0; height: calc(100% + 5px); margin-top: -5px;">
      <app-fiche-chantier [chantier]="chantier" [client]="detail" [edit]="chantier.id"
        [prospectHolding]="detail.prospectHolding || false" (hidefunction)="closeCht();"></app-fiche-chantier>
    </div>
    <div class="col-sm-12" *ngIf="create" style="padding: 0;  height: calc(100% + 5px); margin-top: -5px;">
      <app-fiche-chantier [chantier]="chantier" [client]="detail" (hidefunction)="closeCht();" [edit]="true"
        [prospectHolding]="detail.prospectHolding || false" (addfunction)="createChantier($event)" [add]="true">
      </app-fiche-chantier>
    </div>
  </div>

  <div *ngIf="isModifAgence || isCreateAgence"
    class="col-sm-12 chantier pull-{{position ? 'right' : 'left'}} ficheChantier"
    style="height: 100%; position: absolute;" [ngStyle]="{'width': isDepuisMenuEnHaut ? '100%' : '553px' }">
    <div class="col-sm-12" *ngIf="isModifAgence" style="padding: 0px; height: 100%;">
      <app-fiche-agence [viaFicheClt]="true" [agence]="agence" [client]="detail" (hidefunction)="editAgence();"
        (aftersave)="getValue($event);" [edit]="true"></app-fiche-agence>
    </div>
    <div class="col-sm-12" *ngIf="isCreateAgence" style="padding: 0px; height: 100%;">
      <app-fiche-agence [viaFicheClt]="true" [client]="detail" [add]="true" (hidefunction)="createAgence();"
        (aftersave)="getValue($event);" [edit]="true"></app-fiche-agence>
    </div>
  </div>

  <div class="chantier col-sm-12" [ngClass]="{'position': position,'prixnego':showFactAuto && isDepuisMenuEnHaut}"
    *ngIf="showFactAuto" style="width: calc(100% - 500px); background-color: #f9f9f9;"
    [ngStyle]="{'height': isDepuisMenuEnHaut ? 'calc(100% - 116px)':'100%',width:'100%'}">
    <app-fact-auto [detail]="detail" (show)="showFact()"></app-fact-auto>
  </div>
  <div class="chantier col-sm-12 champAssoTableau"
    [ngClass]="{'position': position, 'prixnego': prixNegocier && isDepuisMenuEnHaut}" *ngIf="showChampWithTableu"
    style="width: calc(100% - 500px); background-color: #f9f9f9;"
    [ngStyle]="{'width': isDepuisMenuEnHaut || prixNegocier ? '100%' : 'calc(100% - 500px)'}">
    <app-ficheclt-contact [detail]="detail" [isedit]="edit" (show)="showListContact()" (persistContactClient)="persistContactClient()"
        *ngIf="contact" [listContactCliendAlreadyLoaded]="persisterListContact"></app-ficheclt-contact>
    <app-user-eco-portail [detail]="detail" (show)="showUserEcoportail()" *ngIf="userEcoportail">
    </app-user-eco-portail>
    <app-document-client [detail]="detail" (show)="showDocument()" *ngIf="document"></app-document-client>
    <app-entreprise-travaux [detail]="detail" (show)="showEntTravaux()" *ngIf="entTravaux"></app-entreprise-travaux>
    <app-iban-bic [detail]="detail" (show)="showIBANBIC()" *ngIf="ibanBic"></app-iban-bic>
    <app-trop-percus [detail]="detail" (show)="showTropPercus()" *ngIf="tropPercus"></app-trop-percus>
    <app-prix-negocies [detail]="detail" [depuisFicheClient]="true" [edit]="edit" [add]="add" (show)="showPrixNego()" *ngIf="prixNegocier"
      [isDepuisMenuEnHaut]="isDepuisMenuEnHaut"></app-prix-negocies>
    <app-nomenclature-nego [detail]="detail" (show)="showNomenclature()" *ngIf="nomenclatureNegocier">
    </app-nomenclature-nego>
    <app-libelle-nego [detail]="detail" (show)="showLibelleNego()" *ngIf="libelleNegocier"></app-libelle-nego>
    <app-liste-cap [detail]="detail" (show)="showCap()" *ngIf="cap"></app-liste-cap>
    <app-liste-cap [detail]="detail" (show)="showCapDND()" [isDND]="true" *ngIf="capDND"></app-liste-cap>
    <app-cap-client [detail]="detail" (show)="showCapClient()" *ngIf="capClient"></app-cap-client>
    <app-limiter-exutoire [detail]="detail" (show)="showLimiteExu()" *ngIf="limiterExutoire"></app-limiter-exutoire>
    <app-montants-teom [detail]="detail" (show)="showMontantsTeom()" *ngIf="montantsTeom"></app-montants-teom>
    <app-compe-coll-tva *ngIf="afficherWinCompteArticleTVA" [setArticle]="detail || {}"
      (callback)="showCompteArticleTVA()"></app-compe-coll-tva>
    <app-gestion-fip [detail]="detail" (show)="showGestionFIPDD()" *ngIf="gestionFIPDD"
      [isDepuisMenuEnHaut]="isDepuisMenuEnHaut" [isDD]="true"></app-gestion-fip>
    <app-gestion-fip [detail]="detail" (show)="showGestionFIPDND()" *ngIf="gestionFIPDND"
      [isDepuisMenuEnHaut]="isDepuisMenuEnHaut" [isDD]="false"></app-gestion-fip>
  </div>


</div>
<div class="spinner" id="spinnerCont" *ngIf="isClick">
  <div class="sk-fading-circle">
    <div class="sk-circle1 sk-circle"></div>
    <div class="sk-circle2 sk-circle"></div>
    <div class="sk-circle3 sk-circle"></div>
    <div class="sk-circle4 sk-circle"></div>
    <div class="sk-circle5 sk-circle"></div>
    <div class="sk-circle6 sk-circle"></div>
    <div class="sk-circle7 sk-circle"></div>
    <div class="sk-circle8 sk-circle"></div>
    <div class="sk-circle9 sk-circle"></div>
    <div class="sk-circle10 sk-circle"></div>
    <div class="sk-circle11 sk-circle"></div>
    <div class="sk-circle12 sk-circle"></div>
  </div>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer</button>
    </div>
  </div>
</ng-template>

<ng-template #confirme>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Il existe déjà un client avec ce nom. Voulez vous tout de même modifier ce
          client ? </label>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class="btn-close btn-valider" (click)="common.closeModal();saveClientModal()"> OUI
      </button>
      <button type="button" class="btn-close btn-non" (click)="common.closeModal();"> NON</button>
    </div>
  </div>
</ng-template>


<ng-template #confirmeDuplicate>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Il existe déjà un client avec le même nom. Souhaitez vous tout de même le créer
          ? </label>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class="btn-close btn-valider"
        (click)="checkDoublon = 'false'; common.closeModal();addClient(false, true);"> OUI
      </button>
      <button type="button" class="btn-close btn-non" (click)="common.closeModal();"> NON</button>
    </div>
  </div>
</ng-template>

<ng-template #loadingSygetrack>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ nomInformatiqueImbrique }} </h4>
  </div>     
  <div class="modal-body" style="height: auto">
      <div>
          <div class="col-sm-12">
              <label class="cofirmemsg" style="font-family: Roboto-Black; font-size: 15px; text-align: justify" 
                  [innerHTML]="msgSygetrack ? msgSygetrack : 'Attente du retour de ' + nomInformatiqueImbrique"></label>
          </div>
      </div>
      
      <div class="text-right" style="margin-top: 15px;" *ngIf="msgSygetrack">
          <button type="button" class=" btn-close btn-valider" (click)="closeSygetrack()"> Fermer </button>
      </div>
  </div>
</ng-template>
